var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PageLayout',{staticClass:"profile-page"},[_c('PageTitle',{staticClass:"page-title"},[_vm._v("Профіль")]),_c('Profile')],1)}
var staticRenderFns = []

export { render, staticRenderFns }